export const getAcceptedFilesText = (formats: string[]): string =>
  `Accepted ${formats.join(", ")} files`;
